import { Check, FileText, Pencil } from "lucide-react";
import type { FC } from "react";

type Props = {
  /** The value as the client reads it ("14 March 1988", "Nigeria"). */
  display: string;
  /** "From your documents · Passport" or "Already on file". */
  source: string;
  labels: { ask: string; yes: string; change: string };
  onConfirm: () => void;
  onChange: () => void;
  /** Foreground as "r, g, b", to match the page's colors. */
  fgRgb: string;
};

/**
 * "We have Amara. Is this right?": what the firm already knows, offered for
 * a yes instead of being typed again.
 */
export const PrefillConfirm: FC<Props> = ({
  display,
  source,
  labels,
  onConfirm,
  onChange,
  fgRgb
}) => (
  <div
    className="flex w-full max-w-140 flex-col gap-4 rounded-2xl border border-solid p-5 backdrop-blur-sm mobile:p-4"
    style={{
      borderColor: `rgba(${fgRgb}, 0.22)`,
      backgroundColor: `rgba(${fgRgb}, 0.08)`,
      color: `rgb(${fgRgb})`
    }}
    data-testid="intake-prefill"
  >
    <span
      className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-[0.06em]"
      style={{ color: `rgba(${fgRgb}, 0.62)` }}
    >
      <FileText className="size-3.5" aria-hidden />
      {source}
    </span>
    <span className="break-words text-2xl font-medium leading-tight mobile:text-xl">
      {display}
    </span>
    <span className="text-lg" style={{ color: `rgba(${fgRgb}, 0.78)` }}>
      {labels.ask}
    </span>
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={onConfirm}
        className="inline-flex min-h-11 items-center gap-2 rounded-lg bg-white px-4 text-lg font-semibold text-[#111827] shadow-[0_8px_18px_rgba(0,0,0,0.18)] transition-colors hover:bg-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
      >
        <Check className="size-4" aria-hidden />
        {labels.yes}
      </button>
      <button
        type="button"
        onClick={onChange}
        className="inline-flex min-h-11 items-center gap-2 rounded-lg border border-solid px-4 text-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
        style={{
          borderColor: `rgba(${fgRgb}, 0.32)`,
          color: `rgb(${fgRgb})`
        }}
      >
        <Pencil className="size-4" aria-hidden />
        {labels.change}
      </button>
    </div>
  </div>
);
